var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",attrs:{"id":"js-header"}},[_c('div',{staticClass:"header__wrapper",attrs:{"id":"js-headerScroll"}},[_c('h1',{staticClass:"header__title"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("../assets/logo/IslandStateMusic.svg"),"alt":"IslandStateMusic"}})])],1),_c('TopNavigation')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }